<template>
  <div class="set-pass">
    <div class="navbar_style" :class="$store.state.user.isNested && 'navbar_style_nested'">
      <Icon class="arrow" name="arrow-left" @click="$router.replace('/home')" />
      <span>{{ l.login_setPwd_nav_title }}</span>
      <div class="icon_box"></div>
    </div>
    <div class="form-box">
      <Form
        @submit="handleCommit"
        @failed="onFailed"
        :show-error-message="true"
      >
        <div class="label-box">
          <div class="label-title">{{ l.login_l_password }}</div>
          <Field
            class="field-input"
            v-model="password"
            center
            clearable
            name="password"
            :type="passType"
            :placeholder="l.login_p_password"
            maxlength="20"
            :rules="[
              { required: true, message: '' }, // l.login_p_code
              {
                validator: checkPass,
                message: `${
                  ![null, undefined].includes(password)
                    ? l.login_pass_no_format
                    : ''
                }`,
              }, // l.login_p_success_code
            ]"
          >
            <template #right-icon>
              <i
                @click="clickEye"
                v-show="!isShowPass"
                style="font-size: 16px; color: #999"
                class="iconfont icon-yanjing"
              ></i>
              <i
                @click="clickEye"
                v-show="isShowPass"
                style="font-size: 16px; color: #999"
                class="iconfont icon-ai-eye"
              ></i>
            </template>
          </Field>
        </div>
        <div class="label-box">
          <div class="label-title">{{ l.login_l_re_password }}</div>
          <Field
            class="field-input"
            v-model="rePassword"
            center
            clearable
            name="rePassword"
            type="password"
            :placeholder="l.login_p_re_password"
            maxlength="20"
            :rules="[
              { required: true, message: '' }, // l.login_p_code
              {
                validator: checkRePassword,
                message: `${
                  ![null, undefined].includes(rePassword)
                    ? l.login_pass_no_same
                    : ''
                }`,
              }, // l.login_p_success_code
            ]"
          />
        </div>
        <div class="tips">{{ l.login_pass_tips }}</div>
        <div style="margin: 30px 0px 0;padding:0 22px;">
          <Button
            class="buttonClass submitBtn"
            :class="isOver && 'submitBtnOver'"
            size="normal"
            type="info"
            block
            native-type="submit"
            >{{ l.login_ok }}</Button
          >
        </div>
      </Form>
      <div style="margin: 10px 0px 0;padding:0 22px;">
        <Button
          class="buttonClass skipBtn"
          :class="isOver && 'submitBtnSkipBtn'"
          size="normal"
          type="info"
          block
          @click="$router.replace('/home')"
          >{{ l.login_jump }}</Button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Icon, Form, Field, Button, Toast } from "vant";

import { checkPass, passEncryption } from "../../utils/index";

import { insertLoginPWD } from "@/services/user";

import l from "@/locales";

export default {
  name: "resetPass",
  components: { Icon, Form, Field, Button },
  data() {
    return {
      passType: "password",
      password: null,
      rePassword: null,
      isShowPass: false,
      l: l.login,
      isOver: false,
    };
  },
  watch: {
    password: "checkForm",
    rePassword: "checkForm",
  },
  methods: {
    checkPass,
    checkRePassword(value) {
      if (value === "") {
        return false;
      } else if (value !== this.password) {
        return false;
      }
      return true;
    },
    checkForm() {
      if (
        this.checkPass(this.password) &&
        this.checkRePassword(this.rePassword)
      ) {
        this.isOver = true;
      } else {
        this.isOver = false;
      }
    },
    handleCommit(e) {
      const { password } = e;
      // 提交点赞业务请求
      const params = {
        newPassWord: passEncryption(password),
      };
      insertLoginPWD(params).then((res) => {
        if (res.code == 200) {
          // 设置成功
          Toast.success({
            message: this.l.login_pass_set_success,
            forbidClick: true,
            onClose: () => {
              this.$router.replace("/home");
            },
          });
        }
      });
    },
    onFailed(err) {
      console.log(err);
    },
    clickEye() {
      this.isShowPass = !this.isShowPass;
      if (this.isShowPass) {
        // 展示
        this.passType = "text";
        return;
      }
      this.passType = "password";
    },
  },
};
</script>

<style lang="less" scoped>
.buttonClass {
  border: none;
  box-sizing: border-box;
}
.submitBtn {
  height: 42px;
  height: 44px;
  background: #eff1fb;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.16);
  border-radius: 22px;
  border: 1px solid #45A1FF;

  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #9d9fa8;
}
.skipBtn {
  height: 42px;
  height: 44px;
  background: #6d707b;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.16);
  border-radius: 22px;

  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.submitBtnOver {
  background: #F8FBFF;
  border: none;
  color: #ffffff;
}
.submitBtnSkipBtn {
  background: #6d707b;
  color: #ffffff;
}

.set-pass {
  height: 100%;
  min-height: 100vh;
  background: #fff;
  .navbar_style {
    .navbar-jump-over {
      color: #999999;
      font-size: 12px;
    }
  }
}
.form-box {
  padding: 20px;
  box-sizing: border-box;

  .label-box {
    .label-title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #3f414c;
      margin-bottom: 10px;
    }
    .field-input {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      padding: 0 20px;
      padding-right: 10px;
      box-sizing: border-box;

      height: 44px;
      background: rgba(69,161,255,0.1);
      border-radius: 21px;
      border: 1px solid #45A1FF;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9d9fa8;

      /deep/ .van-field__error-message {
        position: absolute;
        top: 50%;
        right: 50px;
        transform: translateY(-50%);
      }
    }
  }
  .tips {
    transform: translateY(-10px);
    font-size: 11px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff5225;
  }
}
</style>
